const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';
import Save from './save';

registerBlockType('app/streaming-content', {
  title: 'Conteúdo de Streaming',
  description: 'Seção com Cards em um Slider grande',
  icon: 'slides',
  category: 'design',
  attributes,
  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
